/**
 * 
 * 
 * @export
 * @class TogetherAuctionEndPoint
 */
export class TogetherAuctionEndPoint {
    /**
     * 
     * 
     * @type {Map <String, Object>}
     * @memberof TogetherAuctionEndPoint
     */
    public API_ENDPOINT_PARAMS: Map <String, Object> = new Map <String, Object> ([
         ['submit_dip_get', {
              entity: 'submit_dip',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: false,
         }],
         ['submit_quote_get', {
              entity: 'submit_quote',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['detail_get', {
              entity: 'detail',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['recap_det', {
              entity: 'recap',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['loan_details_get', {
              entity: 'loan_details',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['loan_details_save', {
              entity: 'loan_details',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['applicants_get', {
              entity: 'applicants',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['applicants_save', {
              entity: 'applicants',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['applicants_delete', {
              entity: 'applicants',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['applicant_address_delete', {
              entity: 'applicantaddress',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['business_applicants_save', {
              entity: 'business_applicants',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['business_applicants_delete', {
              entity: 'business_applicants',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['employment_details_get', {
              entity: 'employment_details',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['employment_details_save', {
              entity: 'applicants',
              sub_entity: 'employment_details',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_sub_entity: true,
              has_sub_entity_id: true,
              has_operation: true,
         }],
         ['employment_details_delete', {
              entity: 'applicants',
              sub_entity: 'employment_details',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_sub_entity: true,
              has_sub_entity_id: true,
              has_operation: true,
         }],
         ['security_get', {
              entity: 'security',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['security_save', {
              entity: 'security',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['security_delete', {
              entity: 'security',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['solicitor_get', {
              entity: 'solicitor',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['solicitor_save', {
              entity: 'solicitor',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['solicitor_delete', {
              entity: 'solicitor',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['address_get', {
              prefix: 'address',
              is_case_entity: false,
              has_entity: true,
              has_entity_id: true,
              has_operation: true,
         }],
         ['stage_get', {
              prefix: 'stage',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['stage_save', {
              entity: 'stage',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['certificate_get', {
              prefix: 'certificate',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }],
         ['jwt_get', {
              prefix: 'jwt',
              is_case_entity: false,
              has_entity: true,
              has_operation: true,
         }],
         ['jwt_try', {
              prefix: 'jwt',
              is_case_entity: false,
              has_entity: true,
              has_operation: true,
         }],
         ['company_get', {
              prefix: 'jwt',
              is_case_entity: false,
              has_entity: false,
              has_entity_id: true,
              has_operation: true,
         }],
         ['address_match', {
              entity: 'address',
              is_case_entity: true,
              has_case_entity_id: true,
              has_entity: true,
              has_operation: true,
         }], 
         ['exitingcharge_delete', {
            entity: 'security',
            sub_entity: 'exitingcharge',
            is_case_entity: true,
            has_case_entity_id: true,
            has_entity: true,
            has_entity_id: true,
            has_sub_entity: true,
            has_sub_entity_id: true,
            has_operation: true,
        }],
        ]);
}
